export enum InputStatus {
  success = 'success',
  error = 'error',
  warning = 'warning',
  wait = 'wait',
}
